import { ImageFragmentFragment, SeoFragmentFragment } from '../../__generated__/graphql';

export const mapSeoDataToTags = ({
  featureImage,
  seoData,
}: {
  featureImage: ImageFragmentFragment | null | undefined;
  seoData: null | SeoFragmentFragment | undefined;
}): null | React.JSX.Element => {
  if (!seoData) {
    return null;
  }

  const canonical = seoData.canonical?.replace(process.env.NEXT_PUBLIC_WORDPRESS_URL, process.env.NEXT_PUBLIC_BASE_URL);
  const ogUrl = seoData.opengraphUrl?.replace(process.env.NEXT_PUBLIC_WORDPRESS_URL, process.env.NEXT_PUBLIC_BASE_URL);

  const imgSrc = seoData.opengraphImage?.sourceUrl ?? featureImage?.node.sourceUrl ?? '';
  const imgAlt = seoData.opengraphImage?.altText ?? featureImage?.node.altText ?? '';

  const urlParams = new URLSearchParams();

  if (imgSrc) {
    urlParams.set('image_src', imgSrc);
  }

  const ogImageSrc = `${process.env.NEXT_PUBLIC_BASE_URL}/api/opengraph-image?${urlParams.toString()}`;

  return (
    <>
      {seoData.metaDesc && (
        <meta
          content={seoData.metaDesc}
          name="description"
        />
      )}

      {seoData.title && (
        <title>{seoData.title}</title>
      )}

      {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
      {(seoData.metaKeywords || seoData.focuskw) && (
        <meta
          content={[
            ...seoData.metaKeywords ? [seoData.metaKeywords] : [],
            ...seoData.focuskw ? [seoData.focuskw] : [],
          ].join(', ')}
          name="keywords"
        />
      )}

      <meta
        content={[(seoData.metaRobotsNofollow ?? 'nofollow'), (seoData.metaRobotsNoindex ?? 'noindex')].join(', ')}
        name="robots"
      />

      {canonical && (
        <meta
          content={canonical}
          name="canonical"
        />
      )}

      <meta
        content="en_US"
        property="og:locale"
      />

      {seoData.opengraphAuthor && (
        <meta
          content={seoData.opengraphAuthor}
          property="article:author"
        />
      )}

      {seoData.opengraphDescription && (
        <meta
          content={seoData.opengraphDescription}
          property="og:description"
        />
      )}

      {ogImageSrc && (
        <meta
          content={ogImageSrc}
          property="og:image"
        />
      )}

      {imgAlt && (
        <meta
          content={imgAlt}
          property="og:image:alt"
        />
      )}

      {ogImageSrc && (
        <meta
          content="630"
          property="og:image:height"
        />
      )}

      {ogImageSrc && (
        <meta
          content="1200"
          property="og:image:width"
        />
      )}

      {seoData.opengraphModifiedTime && (
        <meta
          content={seoData.opengraphModifiedTime}
          property="article:modified_time"
        />
      )}

      {seoData.opengraphPublishedTime && (
        <meta
          content={seoData.opengraphPublishedTime}
          property="article:published_time"
        />
      )}

      {seoData.opengraphPublishedTime && (
        <meta
          content={seoData.opengraphPublishedTime}
          property="article:published_time"
        />
      )}

      {seoData.opengraphPublisher && (
        <meta
          content={seoData.opengraphPublisher}
          property="article:publisher"
        />
      )}

      {seoData.opengraphSiteName && (
        <meta
          content={seoData.opengraphSiteName}
          property="og:site_name"
        />
      )}

      {seoData.opengraphTitle && (
        <meta
          content={seoData.opengraphTitle}
          property="og:title"
        />
      )}

      {seoData.opengraphType && (
        <meta
          content={seoData.opengraphType}
          property="og:type"
        />
      )}

      {ogUrl && (
        <meta
          content={ogUrl}
          property="og:url"
        />
      )}

      {seoData.readingTime && (
        <meta
          content={seoData.readingTime.toString()}
          property="article:reading_time"
        />
      )}

      <meta
        content="summary_large_image"
        name="twitter:card"
      />

      {seoData.twitterDescription && (
        <meta
          content={seoData.twitterDescription}
          name="twitter:description"
        />
      )}

      {ogImageSrc && (
        <meta
          content={ogImageSrc}
          name="twitter:image"
        />
      )}

      {imgAlt && (
        <meta
          content={imgAlt}
          name="twitter:image:alt"
        />
      )}

      {ogImageSrc && (
        <meta
          content="630"
          name="twitter:image:height"
        />
      )}

      {ogImageSrc && (
        <meta
          content="1200"
          name="twitter:image:width"
        />
      )}

      {seoData.twitterTitle && (
        <meta
          content={seoData.twitterTitle}
          name="twitter:title"
        />
      )}
    </>
  );
};
